<div class="wrapper">
  <div class="top-content">
    <div class="content-item logo-content">
      <img class="fullfit" [src]="(royaltyFree$ | async)?'assets/logo/tunify_light_royaltyFree.svg':'assets/logo/tunify_light.svg'">
    </div>
    <tun-tab-menu class="menu-content"></tun-tab-menu>
  </div>
  <tun-help-menu class="bottom-content">
  </tun-help-menu>

</div>
